import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=c4f560d4&scoped=true&"
import script from "./DadosGerais.vue?vue&type=script&lang=ts&"
export * from "./DadosGerais.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f560d4",
  null
  
)

export default component.exports